module.exports = __webpack_public_path__ + "img/face2.7e0e382.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face2.jpg
// module id = r58v
// module chunks = 0